import { lazy } from "react";

export const ApplicationListLazy = lazy(() =>
    import("../Applications/ApplicationList").then((module) => ({ default: module.ApplicationList })),
);

export const CompanySectorListLazy = lazy(() =>
    import("../CompanySectorList").then((module) => ({ default: module.CompanySectorList })),
);
